import React, { useState } from "react";
import TrainingSummaryModal from "./trainingSummaryModal";
import TrainingFormModal from "./trainingFormModal"; // Nuevo import
import { instance } from "../../../utils/utils";
import "./styles.css";

const TrainingCard = ({
  item,
  id,
  date,
  type,
  coach,
  status,
  variant,
  trainingPlanId,
  onRefresh,
  isSelectable = false,
  selectedId,
  onSelect,
}) => {
  const isView = variant === "view";
  const isSelected = selectedId === id;
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const formattedDate = (() => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    const rawDate = new Date(`${year}-${month}-${day}T12:00:00`);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const stringWithDe = rawDate.toLocaleDateString("es-ES", options);
    return stringWithDe.replace(/de (\w+) de/, "$1,");
  })();

  const fetchAndShowDetail = async (type, e) => {
    if (e) e.stopPropagation();
    try {
      const res = await instance.get(
          `memberships/new/training_plan/${id}/detail`
      );

      let detail = res.data;

      if (detail.max_records && detail.max_records.length > 0) {
        const exerciseId = detail.max_records[0].id;

        const exercisesRes = await fetch(
            `https://api.staging.elevva.com.co/api/v1/trainings/exercises/${exerciseId}`
        ).then((r) => r.json());

        detail = {
          ...detail,
          exercises: exercisesRes,
        };
      }

      setDetailData(detail);

      if (type === "view") setShowModal(true);
      if (type === "edit") setShowEditModal(true);
    } catch (err) {
      console.error(`❌ Error al obtener detalle (${type}):`, err);
    }
  };

  return (
    <>
      <div
        className={`training-card-container p-1 d-flex flex-column align-items-center gap-1 ${
          isView ? "training-card-container-view" : ""
        }`}
        onClick={() => fetchAndShowDetail("view")}
      >
        <div
          className={`training-card-rectangle d-flex flex-column justify-content-start align-items-start w-100 p-2 ${
            isView ? "training-card-rectangle-view" : ""
          }`}
        >
          <div className="d-flex flex-column gap-3 w-100">
            <div className="d-flex flex-row align-items-center justify-content-between w-100">
              <div
                className={`training-card-chip ${
                  isView ? "training-card-chip-view" : ""
                }`}
              >
                {formattedDate}
              </div>
              <div
                className={`training-card-chip-edit ${
                  isView ? "training-card-chip-edit-view" : ""
                } ${
                  !isSelectable && !isView
                    ? "training-card-chip-edit-hidden"
                    : ""
                }`}
                onClick={(e) => {
                  if (!isSelectable) fetchAndShowDetail("edit", e);
                  e.stopPropagation();
                }}
              >
                {isSelectable ? (
                  <input
                    type="radio"
                    name="duplicate-selection"
                    checked={isSelected}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSelect?.(item);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.01187 14.6556C4.56192 14.6556 3.11185 14.6561 1.6619 14.6556C0.668365 14.6552 0.000396729 13.9879 0.000274658 12.9957C-9.15527e-05 10.0905 -9.15527e-05 7.18591 0.000274658 4.28089C0.000274658 3.2865 0.667145 2.62024 1.66104 2.62C3.95047 2.61951 6.24014 2.61878 8.52957 2.62293C8.66104 2.62293 8.75003 2.58313 8.84134 2.49133C9.48892 1.83606 10.1419 1.18616 10.7937 0.53528C11.5074 -0.177122 12.4367 -0.178587 13.1542 0.531862C13.4833 0.85779 13.8109 1.18567 14.1372 1.51453C14.8321 2.2157 14.8317 3.15344 14.136 3.85193C13.4782 4.51184 12.82 5.172 12.1569 5.82727C12.0674 5.91565 12.036 6.00403 12.0362 6.12683C12.0393 8.43225 12.0397 10.7377 12.0379 13.0431C12.0373 13.8033 11.5774 14.4159 10.8631 14.6007C10.7073 14.641 10.5404 14.6532 10.3783 14.6537C8.92276 14.6574 7.46744 14.6556 6.01187 14.6556ZM10.9906 7.00842C10.923 7.0719 10.88 7.11048 10.8391 7.151C9.54007 8.44934 8.24344 9.75037 6.93826 11.0428C6.82486 11.1552 6.66495 11.2467 6.51053 11.2875C5.30081 11.6085 4.08707 11.9152 2.87405 12.2238C2.7908 12.245 2.70023 12.2609 2.61636 12.2511C2.25613 12.2091 2.0668 11.8759 2.19339 11.507C2.58157 10.3744 2.96964 9.24207 3.36783 8.11316C3.41824 7.97009 3.50613 7.82678 3.61282 7.71936C4.90689 6.41565 6.20731 5.11878 7.50626 3.81995C7.54703 3.77918 7.58572 3.73621 7.65042 3.66736H7.46219C5.52713 3.66736 3.59207 3.66736 1.65689 3.66785C1.24478 3.66809 1.04825 3.86609 1.04825 4.28089C1.048 7.18591 1.048 10.0905 1.04825 12.995C1.04825 13.4066 1.2482 13.6075 1.65823 13.6075C4.56375 13.608 7.4689 13.608 10.3743 13.6078C10.7958 13.6075 10.9903 13.411 10.9904 12.9847C10.9906 11.0555 10.9906 9.12634 10.9906 7.19714C10.9906 7.14514 10.9906 7.09314 10.9906 7.00842ZM10.5009 2.39319C8.55289 4.34021 6.5939 6.29895 4.64664 8.245C5.23245 8.83142 5.83218 9.43103 6.41177 10.0116C8.3638 8.05994 10.3227 6.10144 12.2658 4.15906C11.6797 3.57239 11.0801 2.97278 10.5009 2.39319ZM4.07742 9.27332C3.88773 9.82483 3.6951 10.3842 3.49002 10.9801C4.12735 10.8168 4.72635 10.6635 5.31558 10.5128C4.897 10.0939 4.49149 9.68787 4.07742 9.27332Z"
                      fill="#9DACBD"
                    />
                  </svg>
                )}
              </div>
            </div>
            <div className="d-flex flex-column gap-1">
              <span className="training-card-label fw-semibold">{type}</span>
              <span className="training-card-label">
                <span className="training-card-label-italic">Prof. </span>
                {coach}
              </span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center gap-1">
          <span className="training-card-label">{status}</span>
          <div className="d-flex justify-content-center align-items-center rounded-circle">
            {status === "Pendiente" && (
              <img
                src="/assets/icons-multiple-live/clock-blue.svg"
                alt="Pendiente"
                className="training-card-pending-icon"
              />
            )}
            {status === "Publicado" && (
              <i className="bi bi-check-circle text-success training-card-icon"></i>
            )}
            {status === "Completado" && (
              <i className="bi bi-flag-fill text-primary training-card-icon"></i>
            )}
          </div>
        </div>

        <button
          className={`training-card-button ${
            isView ? "training-card-button-view" : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            fetchAndShowDetail("view");
          }}
        >
          Detalles
        </button>
      </div>

      {detailData && showModal && (
        <TrainingSummaryModal
          show={showModal}
          onClose={() => setShowModal(false)}
          detail={detailData}
        />
      )}

      {detailData && showEditModal && (
        <TrainingFormModal
          show={showEditModal}
          onClose={() => setShowEditModal(false)}
          sessionId={id}
          trainingPlanId={trainingPlanId}
          onRefresh={onRefresh}
        />
      )}
    </>
  );
};

export default TrainingCard;
